export class JobsDataModel {

    accountDetails = {
        accountId: null,
        accountName: null,
        contactId: null,
        contactName: null,
        accountTypeId: null,
        isChanged: false,
        isUpdateFromAccountDetails: null
    };

    jobDetailsModel = {
        accountName: null,
        industryName: null,
        lastActive: null,
        leadSourceName: null,
        createdBy: null,
        createdOn: null,
        accountType: null,
        stageStatus: null,
        activeStatus: null,
        accountDisplayId: null
    };

    summaryModel = {
        appointmentsCount: 0,
        documentsCount: 0,
        notesCount: 0,
    };

    quickQuoteServiceDetails = {
        serviceId: 0,
        serviceCategoryId: 0,
        serviceCost: 0,
        markupPercentage: 0,
        marginPercentage: 0,
        quantity: 0,
        subTotal: 0,
        total: 0,
        markUp: 0,
        servicesDescription: null
    };

    quickQuoteAddresModel = {
        shippingInfoId: null,
        addressId: null,
        contactId: null,
        isQuickContact: false,
        city: null,
        provinceName: null,
        zipCode: null,
        countryName: null
    };

    quickQuoteItem = {
        quantity: null,
        categoryId: null,
        itemId: null,
        itemName: null,
        description: null,
        length: null,
        width: null,
        height: null,
        weight: null,
        value: null,
        extlbs: null,
        extValue: null,
        nmfcClass: null
    };

    containerTotalsModel = {
        idl: 0,
        idw: 0,
        idh: 0,
        totalEXTLBS: 0,
        totalEXTValue: 0
    };


    quickQuoteContainerModel = {
        itemContainerId: null,
        containerName: null,
        containerNumber: null,
        quantity: null,
        containerId: null,
        packagingId: null,
        description: null,
        lineItems: [this.quickQuoteItem],
        containerTotals: Object.assign({}, this.containerTotalsModel)
    };

    orderShippingInformationModel = {
        shippingInfoId: null,
        addressId: null,
        contactId: null,
        accountId: null,
        isQuickContact: null,
        city: null,
        email: null,
        phoneNumber: null,
        provinceName: null,
        zipCode: null,
        countryName: null,
        contactName: null,
        accountName: null,
        addressLine1: null,
        addressLine2: null,
        addressIndicator: null,
        ownedByTenant: '',
        distance: '',
        isChanged: false,
        isShipperAddress: false,
        accountNotes: null,
        isConsigneeAddress: false,
        accountTypeId: null,
    };

    TotalItemsModel = {
        breakdownId: null,
        orderId: null,
        isLock: null,
        isIncluded: null,
        isTaxable: null,
        categoryId: null,
        categoryName: null,
        cost: null,
        subTotal: null,
        markupValue: null,
        markupPercentage: null,
        marginPercentage: null,
        tax: null,
        total: null
    };

    categoryBreakdownModel = {
        quotesTotals: [Object.assign({}, this.TotalItemsModel)],
        overallCost: null,
        overallMarkupValue: null,
        overallMarkupPercentage: null,
        overallMarginPercentage: null,
        overallTax: null,
        overallTotal: null,
        isChanged: false
    };

    jobPostModel = {
        isJob: true,
        assignedTo: null,
        employeeName: null,
        orderId: null,
        isConvertedJob: false,
        IsQuickQuote: false,
        statusId: null,
        jobTypeId: 1,
        IsQuote: false,
        isRush: null,
        isInvoiced: null,
        isPaid: null,
        isHazmat: null,
        poNumber: null,
        deliveryDate: null,
        shippedDate: null,
        account: Object.assign({}, this.accountDetails),
        shipper: Object.assign({}, this.orderShippingInformationModel),
        consignee: Object.assign({}, this.orderShippingInformationModel),
        payer: Object.assign({}, this.orderShippingInformationModel),
        intermediary: Object.assign({}, this.orderShippingInformationModel),
        IsPayerRemoved: false,
        IsIntermediatoryRemoved: false,
        notes: {
            houseBillNote: null,
            internalNote: null,
            isHouseBillNotesChanged: false,
            isInternalNotesChanged: false,
        },
        itemContainers: [this.quickQuoteContainerModel],
        isContainersChanged: false,
        carrierCosts: {
            carrierCostId: null,
            dimWeightFactorId: null,
            carrierId: null,
            serviceName: null,
            serviceDate: null,
            shippingCost: null,
            carrierName: null,
            pro: null,
            isChanged: false
        },
        insurance: {
            isChanged: false,
            insuranceRateId: 0,
            insuranceProviderId: 0,
            orderInsuranceId: null,
            tierId: 0,
            minimum_Charge: 0,
            coverage_Rate: 0,
            markupPercentage: 0,
            coverageCategory: [
                {
                    coverageCategoryId: 0,
                    isActive: true
                }
            ]
        },
        service: [this.quickQuoteServiceDetails],
        isServicesChanged: false,
        estimateBreakdown: this.categoryBreakdownModel,
        totalEstimate: 100,
        ancillariesDetails: []
    };

    shippingDetailsModel = {
        shippingFrom: null,
        shippingTo: null,
        intermediary: null
    };

    orderShipInformationModel = {
        shipper: Object.assign({}, this.orderShippingInformationModel),
        consignee: Object.assign({}, this.orderShippingInformationModel),
        payer: Object.assign({}, this.orderShippingInformationModel),
        intermediary: Object.assign({}, this.orderShippingInformationModel),
    };

    orderDetails = {
        id: null,
        orderId: null,
        isJob: null,
        isQuickQuote: null,
        assignedTo: null,
        employeeName: null,
        leadSourceId: null,
        leadSourceName: null,
        jobTypeId: 1,
        statusId: 5,
        deliveryDate: null,
        shippedDate: null,
        poNumber: null,
        isRush: false,
        isInvoiced: false,
        isPaid: false,
        isHazmat: false,
        isConvertedJob: null,
        isExcessValued: false,
        excessValueStatusId: null,
        account: Object.assign({}, this.accountDetails),
        shipper: Object.assign({}, this.orderShippingInformationModel),
        consignee: Object.assign({}, this.orderShippingInformationModel),
        payer: Object.assign({}, this.orderShippingInformationModel),
        intermediary: Object.assign({}, this.orderShippingInformationModel),
        notes: {
            houseBillNote: null,
            internalNote: null
        },
        itemContainers: [],
        carrierCosts: {
            carrierCostId: 16,
            dimWeightFactorId: 194,
            carrierId: null,
            serviceName: null,
            serviceDate: null,
            shippingCost: null,
            containerDetails: [],
            carrierName: null,
            totals: {
                totalId: null,
                unitWeightOverallTotal: null,
                extWeightOverallTotal: null,
                unitDimWeightOverallTotal: null,
                extDimWeightOverallTotal: null,
                unitCuFeOverallTotal: null,
                extCuFeOverallTotal: null,
                lbsByCuFeOverallTotal: null
            }
        },
        insurance: {
            orderInsuranceId: null,
            insuranceRateId: null,
            insuranceProviderId: null,
            tierId: null,
            minimum_Charge: null,
            coverage_Rate: null,
            markupPercentage: null,
            deductible: null,
            excessValueThreshold: null,
            coverageCategory: []
        },
        service: [],
        estimateBreakdown: null,
        totalEstimate: null,
        orderMaterials: null,
        containerSummary: null,
        isRFQ: false,
        isActive: true
    };

    bulkStatusUpdateModel = {
        orderId: [],
        statusId: 0,
        statusName: null,
        oldStatusId: 0,
        oldStatusName: null,
        notes: null,
        isLocked: true,
        serviceDate: null,
        serviceTime: null,
        isRejected: true
    };

    finalizeJobModel = {
        finalizedDate: null,
    }
}
